import React from 'react';

import { ProgressBar as ProgressBarTPA } from 'wix-ui-tpa/cssVars';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';
import { TextAlignment } from '../../components/ChallengesPage/Settings/challengeSettings/challengeSettings.types';
import { useUser } from '../../contexts/User/UserContext';
import { FCWithChildren } from '@wix/challenges-web-library';
import challengeSettings from '../../components/ParticipantPage/settingsParams';
import { st, classes } from './ProgressBar.st.css';

export interface IProgressBarProps {
  className?: string;
  dataHook?: string;
  value: number;
}

export const ProgressBar: FCWithChildren<IProgressBarProps> = (props) => {
  const { t } = useTranslation();
  const settings = useSettings();
  const { isRTL } = useEnvironment();
  const { isParticipantInLockedState } = useUser();
  const alignment = settings.get(challengeSettings.sidebarLayoutTextAlignment);
  const progressValue = isNaN(props.value) ? 0 : props.value;

  if (isParticipantInLockedState) {
    return null;
  }

  return (
    <div
      className={st(classes.root, {}, props.className)}
      data-hook={props.dataHook}
      dir={alignment === TextAlignment.Right || isRTL ? 'rtl' : 'auto'}
    >
      <ProgressBarTPA
        value={progressValue}
        showProgressIndication={true}
        aria-label={t('challenge.page.progressbar.aria-label')}
      />
    </div>
  );
};
